// 9fbef606107a605d69c0edbcd8029e5d
import { css } from 'styled-components';

const BadgeStyles = css`
  margin-left: 12px;
  display: inline-block;
  position: relative;
  top: 2px;
  height: 15px;
  .verified-tag {
    width: 59px;
    height: 16px;
    overflow: visible;
    display: flex;
  }
  .unverified-tag-button {
    padding: 0;
    margin: 0;
    border: 0;
    box-shadow: none;
    cursor: pointer;
    background: #fff;
    width: 69px;
    height: 16px;
    overflow: visible;
    display: flex;
  }
`;

export default BadgeStyles;
